import * as Styled from "./style";
import { useHandleClickByDevice } from "~/hooks/use-handle-click-by-device";
import { goToWelcomePage } from "~/util/go-to-welcome-page";

type LoginButtonsProps = {
  onHideUserMenu: () => void;
};

export const RegisterPremiumButton = ({ onHideUserMenu }: LoginButtonsProps) => {
  const { handleClickByDevice } = useHandleClickByDevice();

  const register = () => {
    onHideUserMenu();
    goToWelcomePage();
  };

  return (
    <Styled.Button
      name="register"
      color="GRAY50"
      bgColor="YELLOW50"
      mainText="DMMプレミアム登録"
      {...handleClickByDevice(register)}
    />
  );
};
